import React, { useEffect, useRef } from 'react';
import { updateWorkerLocation } from '../api/workerLocationAPI';
import { jwtDecode } from 'jwt-decode';

const LocationTrack = () => {
  const intervalRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');

    // 🛑 STOP tracking if logged out
    if (!token) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    let workerId;
    try {
      const decoded = jwtDecode(token);
      workerId = decoded.workerId || decoded.id || decoded._id;
    } catch {
      console.error('❌ Invalid token');
      return;
    }

    if (!workerId || !navigator.geolocation) return;

    const updateLocation = () => {
      navigator.geolocation.getCurrentPosition(
        async ({ coords }) => {
          try {
            await updateWorkerLocation({
              workerId,
              latitude: coords.latitude,
              longitude: coords.longitude,
            });
          } catch (err) {
            console.error('❌ Location update failed', err.message);
          }
        },
        (err) => console.error('❌ GPS error', err.message),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    };

    // ▶ Start tracking
    updateLocation();
    intervalRef.current = setInterval(updateLocation, 60000);

    // 🧹 Cleanup on user change / unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [localStorage.getItem('token')]); // 🔑 REACTS TO LOGIN / LOGOUT

  return null;
};

export default LocationTrack;
